
<style>
  .desk-cont {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    box-sizing: border-box;
    padding-left: 80px;
    overflow: hidden;
    padding-bottom: 40px;
  }

  .desk-cont > .desk {
    margin-top: 40px;
    float: left;
    margin-bottom: 20px;
  }

  .desk-cont > .desk-work {
    width: 100%;
  }

  .desk-title {
    width: 100%;
    font-size: 20px;
    color: #222;
    font-weight: bold;
    line-height: 30px;
    margin: 0;
    padding: 0;
  }

  .desk-work .desk-list {
    width: 100%;
    float: left;
    margin-top: 30px;
  }

  .desk-work .desk-list .desk-list-li {
    width: 220px;
    height: 70px;
    float: left;
    border-radius: 10px;
    border: 1px solid #e6e6e6;
    display: block;
    margin-right: 50px;
  }

  .desk-work .desk-list .desk-list-li:hover {
    background: #f3f3f4;
    border-color: transparent;
    transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
  }

  .desk-work .desk-list .desk-list-li > img {
    width: 50px;
    float: left;
    margin: 10px 15px 10px 25px;
  }

  .desk-work .desk-list .desk-list-li > .desk-txt {
    line-height: 70px;
    float: left;
    position: relative;
  }

  .desk-txt .desk-txt-pos {
    color: #fff;
    background: #d20303;
    border-radius: 50%;
    line-height: 1;
    padding: 1px 6px;
    font-size: 12px;
  }

  /*新闻中心*/

  .desk-new {
    overflow: hidden;
  }

  .desk-type {
    width: 495px;
    float: left;
    margin-right: 45px;
    margin-bottom: -3px;
  }

  .desk-title .title-edit {
    float: right;
  }

  .desk-title .title-edit > a {
    display: block;
    margin-right: 15px;
    float: left;
  }

  .new-cont {
    width: 100%;
  }

  .new-cont .new-cont-li {
    display: block;
    width: 100%;
    float: left;
    padding: 25px 0 30px 0;
    border-bottom: 1px solid #e2e2e2;
  }

  .new-cont .new-cont-li > img {
    width: 100px;
    height: 80px;
    float: left;
    margin-left: 10px;
  }

  .new-cont .new-cont-li > .new-cont-right {
    width: 360px;
    float: left;
    overflow: hidden;
    margin-left: 18px;
  }

  .new-cont .new-cont-li > .new-cont-right .new-cont-title {
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 34px;
    width: 100%;
    overflow: hidden;
  }

  .new-cont .new-cont-li > .new-cont-right .new-cont-title:hover {
    color: #d20303;
    transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
  }

  .new-cont .new-cont-li > .new-cont-right .new-cont-txt {
    color: #999;
    font-size: 14px;
    width: 100%;
    float: left;
  }

  /*公告*/

  .desk-type-right .new-cont .new-cont-li {
    padding: 15px 0 19px 0;
    box-sizing: border-box;
  }

  .desk-type-right .new-cont .new-cont-li > .new-cont-right {
    width: 285px;
    margin-left: 10px;
    margin-right: 45px;
  }

  .desk-type-right .new-cont .new-cont-li > .new-cont-right .new-cont-txt {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .desk-type-right .userinfo {
    float: left;
    margin-top: 6px;
    width: 150px;
  }

  .desk-type-right .userinfo > .userinfo-img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    float: left;
    margin-right: 5px;
    overflow: hidden;
  }

  .desk-type-right .userinfo > .userinfo-txt {
    float: left;
    width: 90px;
  }

  .desk-type-right .userinfo > .userinfo-txt > span {
    color: #666;
    float: left;
    width: 100%;
    line-height: 23px;
  }

  .desk-type-right .userinfo > .userinfo-txt > p {
    color: #999;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  /*banner*/

  .banner {
    width: 100% !important;
    /* height: 200px !important; */
  }

  .layui-carousel,
  .layui-carousel .slide {
    min-width: 1200px;
    width: 100% !important;
    height: 200px !important;
    background: transparent;
    margin: 0 auto;
    background: url("../../assets/images/banner-bg.png");
    background-position: center center;
    clear: both;
    text-align: center;
  }

  .layui-carousel > [carousel-item]:before {
    content: "";
  }

  .layui-carousel-arrow {
    display: none;
  }

  .layui-carousel .slide > img {
    width: 1200px;
    margin: 0 auto;
  }

  .close {
    width: 90px;
    height: 40px;
    border-radius: 20px;
  }

  .notice-title {
    text-align: center;
    color: #000000;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 40px;
  }

  .notice-info {
    text-align: center;
    font-size: 14px;
    color: #9c9c9c;
    width: 700px;
    margin: 0 auto 50px auto;
    border-bottom: 1px solid #e6e6e6;
    border-top: 1px solid #e6e6e6;
    padding: 5px 0;
  }

  .notice-content {
    text-align: center;
    margin-bottom: 100px;
  }
  .el-header {
    padding: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
</style>
<template>
  <div id="app">
    <el-container>
      <el-header height='70px'><Header/></el-header>
      <el-container>
        <!-- <Left /> -->
        <el-main>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </el-main>
      </el-container>
    </el-container>   
  </div>
</template>

<script>
  import Header from "@/components/common/Header";
  import Footer from "@/components/common/Footer";
  // import Left from '@/components/common/Left.vue';
  export default {
    components: {
      Header, 
      // Left,
      Footer
    },
    created() {
      
    },
    activated () {
      
    },
    data() {
      return {
       
      };
    },
    methods: {
      
    }
  };
</script>







// WEBPACK FOOTER //
// src/components/home/home.vue